
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  IContainerTypesModel,
  IDefaultShippingOrderModel,
  ITypeModel,
  IUserModel
} from "@/api/types";
import { QuotationApprovalDetail, QuotationApproval } from "./types";

import Pagination from "@/components/Pagination/index.vue";
import { Form, Message } from "element-ui";
import {
  batchDeleteShippingOrders,
  confirmPutShipping,
  createShippingOrderContainerType,
  creatShipping,
  deleteShippingOrderContainerType,
  getShippingOrderStatus,
  searchShippingOrder,
  updateShippingOrderContainerType
} from "@/api/shipping-order";
// import { cloneDeep } from "lodash";
import { getContainerType } from "@/api/container-type";
import { getUsersByJobPosition } from "@/api/users";
import {
  getQuotationDetail,
  auditHold,
  auditCancelHold,
  removeQuotation,
  getQuotationStatus,
  generatePI,
  auditPass,
  getConversionExchangeRate
} from "@/api/inquiry";
import {
  getPaymentInfo,
  getPiInfo,
  getTradingTermsTypes,
  getPaymentTypes,
  getSettlementTypes,
  savePaymentInfo,
  getRemittanceAdvice, labelInfoTypes, packageProviders
} from "@/api/proforma";
import { Moment } from "moment";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
// import { isShallow } from "vue";

@Component({
  name: "quotationDetails",
  components: {
    CreateMark: () => import("./components/CreateMark.vue"),
    Pagination,
    CreateFee: () => import("./components/CreateFee.vue"),
    Amount: () => import("./components/Amount.vue"),
    AmountRecording: () => import("./components/AmountRecording.vue")
  }
})
export default class extends Vue {
  // 是否显示所有产品号码
  private showFee = false;
  private showAmount = false;
  private selectedItem = {} as any;
  private tableKey = 0;
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  private customerId = '';

  private conversionExchangeRate = 0;

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [{}] as QuotationApprovalDetail[]
  };

  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false
    },
    {
      label: "收汇单号",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false
    },
    {
      label: "收汇单金额",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false
    },
    {
      label: "登记金额",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false
    },
    {
      label: "登记金额类型",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "金额说明",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "编辑", code: '', click: "handleEdit" },
        {
          name: "删除",
          code: '',
          click: "handleDelete",
          type: "delete"
        }
      ],
      show: true,
      disabled: false,
      width: 100
    }
  ] as any;
  public customerInfo = {} as any;
  public customerInfoFields = [
    {
      label: "PI NO.",
      key: "piNumber"
    },
    {
      label: "交易公司",
      key: "company"
    },
    {
      label: "当前状态",
      key: "status"
    },
    {
      label: "客人信息",
      key: "customerAbbr"
    },
    {
      label: "客人国家",
      key: "customerNation"
    },
    {
      label: "长期定金",
      key: "longTermDeposit"
    },
    {
      label: "产品总数量",
      key: "deliveryQuantity"
    },
    {
      label: "PI金额",
      key: "conversionProfitAmount"
    },
    {
      label: "产品货款",
      key: "deliveryAmount"
    },
    {
      label: "下单时间",
      key: "orderPlacementTime"
    },
    {
      label: "备注",
      key: "remark"
    }
  ] as any;
  public paymentForm = {
    piTemplateRemark: "",
    settlementMethod: "",
    paymentMethod: "",
    accountPeriod: 0,
    paymentRemark: "",
    piAuditor: "",
    internationalTradeTerms: "",
    printLabel: true,
    deposit: true,
    depositAmount: 0,
    depositCurrency: "",
    confirmed: true,
    markList: [],
    hqDeliveryDays: 0,
    poSuffix:"",
  } as any;
  private list = [
    {
      label: "结算方式",
      prop: "settlementMethod",
      key: "settlementMethod",
      type: "select",
      placeholder: "请选择结算方式",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择结算方式",
        trigger: "change"
      },
      options: [],
      labelKey: "desc",
      valueKey: "name"
    },
    {
      label: "付款方式",
      prop: "paymentMethod",
      key: "paymentMethod",
      type: "select",
      placeholder: "请选择付款方式",
      clearable: true,
      maxlength: 10,
      rules: {
        required: true,
        message: "请选择付款方式",
        trigger: "blur"
      },
      options: [],
      labelKey: "desc",
      valueKey: "name"
    },
    {
      label: "Payment term",
      prop: "paymentTerm",
      key: "paymentTerm",
      type: "input",
      placeholder: "请输入",
      clearable: true,
      maxlength: 64
    },
    {
      label: "账期",
      prop: "accountPeriod",
      key: "accountPeriod",
      type: "input",
      placeholder: "请输入账期",
      clearable: true,
      maxlength: 10,
      max: 999,
      unit: "天"
    },
    {
      label: "Remarks",
      prop: "piTemplateRemark",
      key: "piTemplateRemark",
      type: "textarea",
      placeholder: "请输入备注",
      clearable: true,
      maxlength: 256
    },
    {
      label: "付款备注",
      prop: "paymentRemark",
      key: "paymentRemark",
      type: "textarea",
      placeholder: "请输入付款备注",
      clearable: true,
      maxlength: 64
    },

    {
      label: "PI审核人",
      prop: "piAuditor",
      key: "piAuditor",
      type: "input",
      placeholder: "请输入PI审核人",
      clearable: true,
      maxlength: 64
      // rules: {
      //   required: true,
      //   message: "请选择PI审核人",
      //   trigger: "blur",
      // },
    },
    {
      label: "定金金额",
      prop: "depositAmount",
      key: "depositAmount",
      type: "inputNumber",
      placeholder: "请输入定金金额",
      clearable: true,
      disabled: false,
      maxlength: 10
    },
    {
      label: "定金",
      prop: "deposit",
      key: "deposit",
      type: "checkbox_item",
      placeholder: "",
      clearable: true,
      maxlength: 10
    },
    {
      label: "交易类型",
      prop: "internationalTradeTerms",
      key: "internationalTradeTerms",
      type: "select",
      placeholder: "请选择交易类型",
      clearable: true,
      maxlength: 10,
      options: [],
      labelKey: "desc",
      valueKey: "name"
    },
    {
      label: "贴标资料",
      prop: "labelInfoDownloadType",
      key: "labelInfoDownloadType",
      type: "select",
      placeholder: "请选择",
      clearable: true,
      rules: {
        required: true,
        message: "请选择贴标资料类型",
        trigger: "blur"
      },
      options: [],
      labelKey: "desc",
      valueKey: "name"
    },
    {
      label: "贴标交齐天数",
      prop: "labelingDeadline",
      key: "labelingDeadline",
      type: "inputNumber",
      placeholder: "请输入",
      clearable: true,
    },
    {
      label: "包装提供方",
      prop: "packageProvider",
      key: "packageProvider",
      type: "select",
      placeholder: "请选择",
      clearable: false,
      options: [],
      labelKey: "desc",
      valueKey: "name"
    },
    {
      label: "采购订单后缀",
      prop: "poSuffix",
      key: "poSuffix",
      type: "input",
      placeholder: "请输入采购订单后缀",
      clearable: true,
      maxlength: 64,
      rules: {
        validator: function(rule, value, callback) {
          if (value && /-/.test(value)) {
            callback(new Error('采购订单后缀不能包含 "-"'));
          } else {
            callback();
          }
        }
      },
    },
  ];
  private feeTable = [];
  public feeCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false
    },
    {
      label: "费用类型",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false
    },
    {
      label: "金额",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false
    },
    {
      label: "备注",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "编辑", code: '', click: "handleEdit" },
        {
          name: "删除",
          code: '',
          click: "handleDelete",
          type: "delete"
        }
      ],
      show: true,
      disabled: false,
      width: 100
    }
  ] as any;
  private recordTable = [];
  private id = "";
  private paymentInfo = {};
  private piInfo = {};
  private remittanceAdviceList = [] as any;
  private remittanceAdviceListSon = [] as any;

  created() {
    this.id = this.$route.query.id as string;
    this.customerId = this.$route.query.customerId as string;
    this.init();
  }

  activated() {
    this.init();
  }

  private async init() {
    await this.getPaymentInfo();
    await this.getPiInfo();
    await this.getTradingTermsTypes();
    await this.getPaymentTypes();
    await this.getSettlementTypes();
    await this.getRemittanceAdvice();
    await this.getLabelInfoTypes();
    await this.getPackageProvider();
    // this.getList();
  }

  private async getPackageProvider() {
    const types = await packageProviders() as any;
    this.list[12].options = types;
  }

  private async getLabelInfoTypes() {
    const types: any = await labelInfoTypes();
    this.list.forEach((item,index) => {
      if (item.key === 'labelInfoDownloadType') {
        this.list[index].options = types;
      }
    })
  }

  private async getRemittanceAdvice() {
    let params = {
      customerId: this.customerId,
      piId: this.id,
    }
    const res:any = await getRemittanceAdvice(params)
    this.remittanceAdviceListSon = res
  }

  private formUpdate(obj) {
    let index = this.list.findIndex(item => item.key === "depositAmount");
    if (obj.deposit) {
      this.list[index].disabled = false;
    } else {
      this.list[index].disabled = true;
      this.paymentForm.depositAmount = null;
    }
  }

  private async getPiInfo() {
    const res: any = await getPiInfo(this.id);
    this.piInfo = res;
  }

  private selectRowOfAmountRecording(row) {
    console.log('row',row)
    this.remittanceAdviceList.push(row)
  }

  private async getPaymentInfo() {
    const res: any = await getPaymentInfo(this.id);
    const { otherFees, shippingMarks,registrationAmountResList } = res;
    (this.$refs.otherFees as any).table.list = otherFees;
    (this.$refs.shippingMarks as any).table.list = shippingMarks;
    this.remittanceAdviceList = registrationAmountResList;
    this.remittanceAdviceList.map(item => {
      item.amountReceived = item.remittanceAdviceAmountReceived
    })
    this.paymentInfo = res;
    this.paymentForm = {
      ...res
    };
    this.formUpdate(this.paymentForm);
  }

  //
  private async getTradingTermsTypes() {
    const res: any = await getTradingTermsTypes();
    this.list[9].options = res;
    console.log('交易类型',res)
  }

  // 付款方式
  private async getPaymentTypes() {
    const res: any = await getPaymentTypes();
    this.list[1].options = res;
  }

  // 结算方式
  private async getSettlementTypes() {
    const res: any = await getSettlementTypes();
    this.list[0].options = res;
  }

  private handleSuccess() {
    this.showFee = false;
    this.getList();
  }

  private handleAddMark() {
    this.paymentForm.markList.push({
      value: ""
    });
  }

  // 删除唛头
  private handleDeleteMark(index) {
    this.paymentForm.markList.splice(index, 1);
  }

  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
    this.getList();
  }

  private DeleteThisData(e) {
    this.remittanceAdviceList.splice(e,1)
  }

  public async handleFee() {
    this.showFee = true;
  }

  public async handleAmount() {
    this.showAmount = true;
  }

  private async getList() {
    const params = {
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize
    };
    this.listLoading = false;
    const { total, list }: any = await getQuotationDetail(params);
    this.table.total = +total;
    this.table.list = list;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            let otherFees = (this.$refs.otherFees as any).table.list;
            let shippingMarks = (this.$refs.shippingMarks as any).table?.list;
            delete this.paymentForm.otherFees;
            delete this.paymentForm.shippingMarks;
            delete this.paymentForm.registrationAmountResList;
            await savePaymentInfo(this.id, {
              ...this.paymentForm,
              otherFeeList: otherFees,
              markList: shippingMarks,
              registrationAmountList: this.remittanceAdviceList
            });
            this.$notify({
              title: "成功",
              message: "保存成功",
              type: "success",
              duration: 2000
            });
            await this.getPiInfo();
            this.$router.go(-1);
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }
}
